import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export type BookSort = 'title-asc' | 'title-desc' | 'subject';

interface BookFilterProps {
    search: string;
    // subject: string;
    // subjects: string[];
    sort: BookSort;
    onSearchChange: (search: string) => void;
    // onSubjectChange: (subject: string) => void;
    onSortChange: (sort: BookSort) => void;
}

export function BookFilter({ search, sort, onSearchChange, onSortChange }: BookFilterProps) {
    return (
        <div className="border-border bg-card rounded-lg border p-4">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <label className="space-y-2 sm:col-span-2 lg:col-span-1">
                    <span className="text-sm font-medium">Search</span>
                    <Input
                        value={search}
                        onChange={event => onSearchChange(event.target.value)}
                        placeholder="Name or subject"
                        className="h-9"
                    />
                </label>

                {/* <label className="space-y-2">
                    <span className="text-sm font-medium">Subject</span>
                    <Select
                        value={subject}
                        onValueChange={onSubjectChange}
                    >
                        <SelectTrigger className="h-9">
                            <SelectValue placeholder="All subjects" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="all">All subjects</SelectItem>
                            {subjects.map(subjectName => (
                                <SelectItem
                                    key={subjectName}
                                    value={subjectName}
                                >
                                    {subjectName}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </label> */}

                <label className="space-y-2">
                    <span className="text-sm font-medium">Sort</span>
                    <Select
                        value={sort}
                        onValueChange={value => onSortChange(value as BookSort)}
                    >
                        <SelectTrigger className="h-9">
                            <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="title-asc">Name A-Z</SelectItem>
                            <SelectItem value="title-desc">Name Z-A</SelectItem>
                        </SelectContent>
                    </Select>
                </label>
            </div>
        </div>
    );
}
